import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from "../pages/login/login";
import { ProfilePage } from '../pages/profile/profile';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { MaterialPage } from '../pages/material/material';
import { ProjectPage } from '../pages/project/project';
import { TaskListPage } from '../pages/taskList/taskList';
import { DataProvider } from '../providers/data/data';
import { AdminDashboardPage } from '../pages/adminDashboard/adminDashboard';
import { CustomersPage } from '../pages/customers/customers';
import { UserRequestPage } from '../pages/userRequest/userRequest';
import { CalendarPage } from '../pages/calendar/calendar';
import { SystemCalendarPage } from '../pages/systemCalendar/systemCalendar';
import { JobsPage } from '../pages/jobs/jobs';
import { CompanyInfoPage } from '../pages/companyInfo/companyInfo';
import { InfoSearchPage } from '../pages/InfoSearch/InfoSearch';
import { ProjectMorePage } from '../pages/projectMore/projectMore';
import { connectCompanyPage } from '../pages/connectCompany/connectCompany';



@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = LoginPage;
  @ViewChild(Nav) nav: Nav;
  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, public app: App,
    private data: DataProvider,) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
    });
    this.data.currentTabName = 'Нэвтрэх хэсэг';
  }

  public profile() {
    this.nav.push(ProfilePage);
  }

  public dashboard() {
    this.nav.push(DashboardPage);
  }

  public adminDashboard() {
    this.nav.push(AdminDashboardPage);
  }

  public material() {
    this.nav.push(MaterialPage);
  }

  public logout() {
    this.data.userId = null;
    this.data.email = null;
    this.data.image = null;
    this.data.jobName = null;
    this.data.slackName = null;
    this.data.type = null;
    this.data.userName = null;
    this.data.workTime = null;
    this.data.workYearIn = null;
    this.data.workYearStart = null;
    this.data.companyId = null;

    var nav = this.app.getRootNavs();
    nav[0].setRoot(LoginPage);
  }

  public task() {
    this.nav.push(TaskListPage);
  }

  public project() {
    this.nav.push(ProjectPage);
  }

  public back() {
    if(document.getElementById('backFrom').innerText == '') {
      let nav = this.app.getRootNavs();
      // if(parseInt(this.data.type) == 2 || parseInt(this.data.type) == 4) {
      //   nav[0].setRoot(AdminDashboardPage);
      //   // this.nav.popTo(AdminDashboardPage, {});
      // } else {
        nav[0].setRoot(DashboardPage);
        // this.nav.popTo(DashboardPage, {});
      // }
    } else {
      this.nav.push(AdminDashboardPage);
    }
  }

  public customers() {
    this.nav.push(CustomersPage);
  }

  public userRequest() {
    this.nav.push(UserRequestPage);
  }

  public calendar() {
   this.nav.push(CalendarPage);
  }

  public systemCalendar() {
    this.nav.push(SystemCalendarPage);
  }

  public jobs() {
    this.nav.push(JobsPage);
  }

  public companyInfo() {
    this.nav.push(CompanyInfoPage);
  }

  public InfoSearch() {
    this.nav.push(InfoSearchPage);
  }

  public projectMore() {
    this.nav.push(ProjectMorePage);
  }

  public connectCompany() {
    this.nav.push(connectCompanyPage);
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts